var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgOffice365 = function SvgOffice365(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6l11.014-4 6.007 1.5v17L14.014 22 3 18l11.014 1.5V5L7.005 6.5v10L3 18V6z",
    fill: "#A4B8D1"
  })));
};
export default SvgOffice365;